import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { TipologiaIncaricoDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class TipologiaIncaricoApiClient extends BaseCRUDApiClient<TipologiaIncaricoDto> {
  baseUrl = this.config.apiEndpoint + '/tipologia-incarico';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
